import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { reduxForm, Field } from 'redux-form';

import { List, Map, fromJS } from 'immutable';

import { PieChart, Pie, Cell, Sector, Tooltip as ChartTooltip } from 'recharts';
import { Icon } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import { DetailTemplate, Button } from 'components';

import Scrollbar from 'libs/Scrollbar';
import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import { TagItem, MaterialSnackbar, ModalTagTargetAdd, ModalTagTargetDelete, Loading } from 'components';

import styles from './TargetDetail.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class TargetDetailMulti extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      mergeDetail,
      targetNoArray,
      tagTargetArray,
      tagDataByTagNo,
      targetDataByTargetNo,
      isEditType,
      isEditData,
      isSnackbar,
      isModal,
      isClicked,
      isLoadingMergeDetail,
      errorMessage,
      onToggleSnackbar,
      onToggleDetailView,
      onToggleModal,
      onAddTagTarget,
      onDeleteTagTarget,
      handleChangeModalTag,
      onMoveScroll,
      onRefRegister,
      handleSearchChange,
      handleBlur,
      searchText
    } = this.props;
    // 대상자 전체 선택 처리
    const { totalTarget, isAllCheckTarget } = this.props;
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    // 대상자
    // > 선택된 대상자 수
    // > 소속, 직급 일괄 수정 (상단에 dropdown으로 해도 좋을듯)
    // 태그

    const btDatas = [
      {
        id: 'move-1',
        iconName: 'id card outline',
        content: defineMessages(formatMessage({ id: 'ExamDetailMulti_1', defaultMessage: '대상자 정보' }))
      },
      {
        id: 'move-2',
        iconName: 'hashtag',
        content: defineMessages(formatMessage({ id: 'ExamDetailMulti_2', defaultMessage: '태그' }))
      }
    ];

    // -------------------------------------- 대상자 정보 -----------------------------------------

    const tagListData = {};
    const tagAddArray = [];
    const tagDeleteArray = [];

    if (targetNoArray.size > 1) {
      // 추가 리스트

      tagDataByTagNo.map((tag, tagNo) => {
        const color = tagDataByTagNo.getIn([String(tagNo), 'color']);
        let setColor = '#db2828';
        color === 'red' && (setColor = '#ff0000');
        color === 'orange' && (setColor = '#ff8a00');
        color === 'yellow' && (setColor = '#ffcc00');
        color === 'olive' && (setColor = '#c1d91f');
        color === 'lightgreen' && (setColor = '#76ea05');
        color === 'green' && (setColor = '#12bb52');
        color === 'pink' && (setColor = '#d90cec');
        color === 'purple' && (setColor = '#9c00ff');
        color === 'violet' && (setColor = '#632fda');
        color === 'blue' && (setColor = '#125be1');
        color === 'lightblue' && (setColor = '#0ea7e7');
        color === 'lightpink' && (setColor = '#ff6ce2');
        color === 'emerald' && (setColor = '#02dcc5');
        color === 'plum' && (setColor = '#ff1a86');
        color === 'darkplum' && (setColor = '#c90d6a');
        color === 'brown' && (setColor = '#a44200');
        color === 'ash' && (setColor = '#bb9b7c');
        color === 'apricot' && (setColor = '#ffb99a');
        color === 'grey' && (setColor = '#767676');
        color === 'black' && (setColor = '#1b1c1d');

        tagAddArray.push({
          key: tagNo,
          value: Number(tagNo),
          text: tagDataByTagNo.getIn([String(tagNo), 'tagName']),
          data: {
            color: 'tag-label-' + color
          },
          content: (
            <div className={cx('tage-target-add')}>
              <div className={cx('tag-color')} style={{ backgroundColor: setColor }} />
              <div className={cx('tag-name')}>{tagDataByTagNo.getIn([String(tagNo), 'tagName'])}</div>
              {/* <div>{tagDataByTagNo.getIn([String(tagNo), 'targetCount'])}</div> */}
            </div>
          )
          // text: tagDataByTagNo.getIn([String(tagNo), 'tagName']),
        });
      });

      // 삭제 리스트
      // 모든 대상자 선택일 경우 모든 태그를 리스트로 보여준다.
      if (isAllCheckTarget === 2) {
        tagDataByTagNo.map((tag, tagNo) => {
          const color = tagDataByTagNo.getIn([String(tagNo), 'color']);
          let setColor = '#db2828';
          color === 'red' && (setColor = '#ff0000');
          color === 'orange' && (setColor = '#ff8a00');
          color === 'yellow' && (setColor = '#ffcc00');
          color === 'olive' && (setColor = '#c1d91f');
          color === 'lightgreen' && (setColor = '#76ea05');
          color === 'green' && (setColor = '#12bb52');
          color === 'pink' && (setColor = '#d90cec');
          color === 'purple' && (setColor = '#9c00ff');
          color === 'violet' && (setColor = '#632fda');
          color === 'blue' && (setColor = '#125be1');
          color === 'lightblue' && (setColor = '#0ea7e7');
          color === 'lightpink' && (setColor = '#ff6ce2');
          color === 'emerald' && (setColor = '#02dcc5');
          color === 'plum' && (setColor = '#ff1a86');
          color === 'darkplum' && (setColor = '#c90d6a');
          color === 'brown' && (setColor = '#a44200');
          color === 'ash' && (setColor = '#bb9b7c');
          color === 'apricot' && (setColor = '#ffb99a');
          color === 'grey' && (setColor = '#767676');
          color === 'black' && (setColor = '#1b1c1d');

          tagDeleteArray.push({
            key: tagNo,
            value: Number(tagNo),
            text: tagDataByTagNo.getIn([String(tagNo), 'tagName']),
            data: {
              color: 'tag-label-' + color
            },
            content: (
              <div className={cx('tage-target-add')}>
                <div className={cx('tag-color')} style={{ backgroundColor: setColor }} />
                <div className={cx('tag-name')}>{tagDataByTagNo.getIn([String(tagNo), 'tagName'])}</div>
                {/* <div>{tagDataByTagNo.getIn([String(tagNo), 'targetCount'])}</div> */}
              </div>
            )
            // text: tagDataByTagNo.getIn([String(tagNo), 'tagName']),
          });
        });
      } else {
        targetNoArray.map((targetNo, i) => {
          const tagList = targetDataByTargetNo.getIn([String(targetNoArray.get(i)), 'tagList']);
          if (!!tagList) {
            tagList.map(tagNo => {
              if (!!tagNo && tagDataByTagNo.get(String(tagNo))) {
                if (typeof tagListData[tagNo] === 'undefined') {
                  const color = tagDataByTagNo.getIn([String(tagNo), 'color']);
                  let setColor = '#db2828';
                  color === 'red' && (setColor = '#ff0000');
                  color === 'orange' && (setColor = '#ff8a00');
                  color === 'yellow' && (setColor = '#ffcc00');
                  color === 'olive' && (setColor = '#c1d91f');
                  color === 'lightgreen' && (setColor = '#76ea05');
                  color === 'green' && (setColor = '#12bb52');
                  color === 'pink' && (setColor = '#d90cec');
                  color === 'purple' && (setColor = '#9c00ff');
                  color === 'violet' && (setColor = '#632fda');
                  color === 'blue' && (setColor = '#125be1');
                  color === 'lightblue' && (setColor = '#0ea7e7');
                  color === 'lightpink' && (setColor = '#ff6ce2');
                  color === 'emerald' && (setColor = '#02dcc5');
                  color === 'plum' && (setColor = '#ff1a86');
                  color === 'darkplum' && (setColor = '#c90d6a');
                  color === 'brown' && (setColor = '#a44200');
                  color === 'ash' && (setColor = '#bb9b7c');
                  color === 'apricot' && (setColor = '#ffb99a');
                  color === 'grey' && (setColor = '#767676');
                  color === 'black' && (setColor = '#1b1c1d');

                  tagListData[tagNo] = tagDataByTagNo.get(String(tagNo)).toJS();
                  tagListData[tagNo]['count'] = 1;

                  tagDeleteArray.push({
                    key: tagNo,
                    value: Number(tagNo),
                    text: tagDataByTagNo.getIn([String(tagNo), 'tagName']),
                    data: {
                      color: 'tag-label-' + color
                    },
                    content: (
                      <div className={cx('tage-target-add')}>
                        <div className={cx('tag-color')} style={{ backgroundColor: setColor }} />
                        <div className={cx('tag-name')}>{tagDataByTagNo.getIn([String(tagNo), 'tagName'])}</div>
                        {/* <div>{tagDataByTagNo.getIn([String(tagNo), 'targetCount'])}</div> */}
                      </div>
                    )
                    // text: tagDataByTagNo.getIn([String(tagNo), 'tagName']),
                  });
                } else {
                  tagListData[tagNo]['count'] += 1;
                }
              }
            });
          } else {
            return false;
          }
        });
      }
    } else {
      // 에러
      console.log('대상자 멀티 - 에러 발생');
      return false;
    }

    // ----------------------------------------- 태그 -----------------------------------------
    let TagListComponent = (
      <div className={cx('tagTarget-area')}>
        <div>{defineMessages(formatMessage({ id: 'ExamDetailMulti_3', defaultMessage: '태그를 등록하세요' }))}</div>
      </div>
    );

    // 모든 대상자 선택시 태그리스트를 안보여준다.
    if (isAllCheckTarget === 2) {
      TagListComponent = (
        <div className={cx('tagTarget-area')}>
          <Button
            className={cx('bt-tagTarget')}
            size="mini"
            buttonColor="#dddddd"
            fontColor="#333333"
            onClick={() => {
              onToggleModal('tagTargetAdd');
            }}>
            <Icon name="add" />
            {defineMessages(formatMessage({ id: 'ExamDetailMulti_5', defaultMessage: '태그 일괄 추가' }))}
          </Button>
          <Button
            className={cx('bt-tagTarget')}
            size="mini"
            buttonColor="#dddddd"
            fontColor="#333333"
            onClick={() => {
              onToggleModal('tagTargetDelete');
            }}>
            <Icon name="trash" />
            {defineMessages(formatMessage({ id: 'ExamDetailMulti_6', defaultMessage: '태그 일괄 삭제' }))}
          </Button>
        </div>
      );

      // 태그가 1개라도 있을 경우
    } else if (Object.keys(tagListData).length > 0) {
      const TagInnerComponent = [];
      for (const tagNo in tagListData) {
        if (tagListData.hasOwnProperty(tagNo)) {
          if (tagNo && typeof tagDataByTagNo.get(String(tagNo)) !== 'undefined') {
            TagInnerComponent.push(
              <TagItem
                key={tagNo}
                tagItem={fromJS(tagListData[tagNo])}
                className={cx('targetItem-tagItem')}
                size="small"
              />
            );
          }
        }
      }

      TagListComponent = (
        <div className={cx('tagTarget-area')}>
          <div className={cx('editMode-area')}>{TagInnerComponent}</div>
        </div>
      );
    }

    const infectionFileArray = [
      // 데이터가 없을때 표시
      {
        name: '',
        color: '',
        value: mergeDetail.allTarget > 0 ? 0 : 100,
        label: '',
        percent: mergeDetail.allTarget > 0 ? 0 : 100
      },
      {
        name: 'target',
        color: '#797979',
        value: mergeDetail.target,
        label: defineMessages(formatMessage({ id: 'Target_22', defaultMessage: '결과 없음' })),
        percent: (mergeDetail.target / mergeDetail.allTarget * 100).toFixed(0)
      },
      {
        name: 'send',
        color: '#14ae96',
        value: mergeDetail.send,
        label: defineMessages(formatMessage({ id: 'TargetItem_10', defaultMessage: '양호' })),
        percent: (mergeDetail.send / mergeDetail.allTarget * 100).toFixed(0)
      },
      {
        name: 'read',
        color: '#f69c2e',
        value: mergeDetail.read,
        label: defineMessages(formatMessage({ id: 'Target_24', defaultMessage: '메일 열람' })),
        percent: (mergeDetail.read / mergeDetail.allTarget * 100).toFixed(0)
      },
      {
        name: 'download',
        color: '#711bd1',
        value: mergeDetail.download,
        label: defineMessages(formatMessage({ id: 'Target_25', defaultMessage: '파일 다운' })),
        percent: (mergeDetail.download / mergeDetail.allTarget * 100).toFixed(0)
      },
      {
        name: 'infection',
        color: '#dc3030',
        value: mergeDetail.infection,
        label: defineMessages(formatMessage({ id: 'Target_26', defaultMessage: 'PC 감염' })),
        percent: (mergeDetail.infection / mergeDetail.allTarget * 100).toFixed(0)
      }
    ];

    return (
      <DetailTemplate btDatas={btDatas} onMoveScroll={onMoveScroll} onToggleDetailView={onToggleDetailView}>
        <MaterialSnackbar isSnackbar={isSnackbar} onToggleSnackbar={onToggleSnackbar} />
        <Scrollbar
          ref={Scroll => {
            onRefRegister('scroll', Scroll);
          }}>
          <div className={cx('element-wrapper')}>
            {isLoadingMergeDetail && (
              <div className={cx('Loading')}>
                <Loading content={'Loading...'} />
              </div>
            )}
            {/* ----------------------------------------- 대상자 정보 ----------------------------------------- */}
            <div className={cx('element')}>
              <div
                className={cx('segment-title')}
                ref={ref => {
                  onRefRegister('move-1', ref);
                }}>
                <span className={cx('toggle-title bold')}>
                  {defineMessages(formatMessage({ id: 'ExamDetailMulti_1', defaultMessage: '대상자 정보' }))}
                </span>
              </div>
              <div className={cx('segment-content')}>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetStatus-title')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailMulti_4', defaultMessage: '선택된 대상자 수' }))}
                  </div>
                  <div className={cx('targetStatus-content ml-10')}>
                    {(!!mergeDetail.allTarget ? mergeDetail.allTarget : 0) +
                      defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                  </div>
                </div>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetStatus-title')}>
                    {defineMessages(formatMessage({ id: 'TargetItem_8', defaultMessage: '최근 훈련 결과' }))}
                  </div>
                </div>

                <div className={cx('targetStatus')}>
                  <div className={cx('examResult-area')}>
                    <PieChart width={120} height={120}>
                      <Pie
                        dataKey="value"
                        data={[
                          {
                            name: 'background',
                            value: 100
                          }
                        ]}
                        cx={55}
                        cy={55}
                        paddingAngle={0}
                        innerRadius={18}
                        outerRadius={56}>
                        <Cell fill="#f7f7f7" />
                      </Pie>
                      <Pie
                        dataKey="value"
                        data={infectionFileArray}
                        cx={55}
                        cy={55}
                        innerRadius={23}
                        outerRadius={51}
                        startAngle={450}
                        endAngle={90}
                        paddingAngle={-1}
                        activeIndex={0}
                        activeShape={e => {
                          const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = e;
                          return (
                            <g>
                              {/* 그라데이션 효과 */}
                              <defs>
                                <linearGradient id="797979" x1="0" y1="0" x2="0" y2="1">
                                  <stop offset="0%" stopColor="#797979" />
                                  <stop offset="100%" stopColor="#5d5d5d" />
                                </linearGradient>
                              </defs>
                              <defs>
                                <linearGradient id="14ae96" x1="0" y1="0" x2="0" y2="1">
                                  <stop offset="0%" stopColor="#14ae96" />
                                  <stop offset="100%" stopColor="#058f88" />
                                </linearGradient>
                              </defs>
                              <defs>
                                <linearGradient id="f69c2e" x1="0" y1="0" x2="0" y2="1">
                                  <stop offset="0%" stopColor="#f69c2e" />
                                  <stop offset="100%" stopColor="#ff8715" />
                                </linearGradient>
                              </defs>
                              <defs>
                                <linearGradient id="711bd1" x1="0" y1="0" x2="0" y2="1">
                                  <stop offset="0%" stopColor="#711bd1" />
                                  <stop offset="100%" stopColor="#4506a1" />
                                </linearGradient>
                              </defs>
                              <defs>
                                <linearGradient id="dc3030" x1="0" y1="0" x2="0" y2="1">
                                  <stop offset="0%" stopColor="#dc3030" />
                                  <stop offset="100%" stopColor="#bd0e0e" />
                                </linearGradient>
                              </defs>

                              {/* 차트의 기본 형태 영역 */}
                              <Sector
                                cx={cx}
                                cy={cy}
                                innerRadius={innerRadius}
                                outerRadius={outerRadius}
                                startAngle={startAngle}
                                endAngle={endAngle}
                                fill="rgb(230, 230, 230)"
                              />
                              {/* 차트의 확장 처리 */}
                              <Sector
                                cx={cx}
                                cy={cy}
                                startAngle={startAngle}
                                endAngle={endAngle}
                                innerRadius={outerRadius - 1}
                                outerRadius={outerRadius + 8}
                                fill="rgb(230, 230, 230)"
                              />
                            </g>
                          );
                        }}>
                        {/* cell 안에 그라데이션 효과 */}
                        {infectionFileArray.map((entry, index) => (
                          <Cell key={index} fill={'url(' + entry.color + ')'} />
                        ))}
                      </Pie>
                      <ChartTooltip
                        content={({ payload }) => {
                          return payload.map((entry, index) => {
                            if (entry.name !== 'background') {
                              return (
                                <div className={cx('chart2-tooltip')} key={index}>
                                  <div className={cx('name')}>{entry.payload.label}</div>
                                  <div className={cx('value')}>
                                    {entry.value +
                                      defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' })) +
                                      ' (' +
                                      entry.payload.percent +
                                      '%)'}
                                  </div>
                                </div>
                              );
                            }
                          });
                        }}
                      />
                    </PieChart>
                    <div className={cx('examResult-content')}>
                      <div className={cx('examResult')}>
                        <div className={cx('chartData-icon')} />
                        <div className={cx('examResult-title')}>
                          {defineMessages(formatMessage({ id: 'Target_22', defaultMessage: '결과 없음' }))}
                        </div>
                        <div className={cx('ea')}>
                          {(!!mergeDetail.target ? mergeDetail.target : 0) +
                            defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                        </div>
                      </div>

                      <div className={cx('examResult')}>
                        <div className={cx('chartData-icon brand')} />
                        <div className={cx('examResult-title')}>
                          {defineMessages(formatMessage({ id: 'TargetItem_10', defaultMessage: '양호' }))}
                        </div>
                        <div className={cx('ea')}>
                          {(!!mergeDetail.send ? mergeDetail.send : 0) +
                            defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                        </div>
                      </div>

                      <div className={cx('examResult ')}>
                        <div className={cx('chartData-icon orange')} />
                        <div className={cx('examResult-title')}>
                          {defineMessages(formatMessage({ id: 'Target_24', defaultMessage: '메일 열람' }))}
                        </div>
                        <div className={cx('ea')}>
                          {(!!mergeDetail.read ? mergeDetail.read : 0) +
                            defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                        </div>
                      </div>

                      <div className={cx('examResult ')}>
                        <div className={cx('chartData-icon down')} />
                        <div className={cx('examResult-title')}>
                          {defineMessages(formatMessage({ id: 'Target_25', defaultMessage: '파일 다운' }))}
                        </div>
                        <div className={cx('ea')}>
                          {(!!mergeDetail.download ? mergeDetail.download : 0) +
                            defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                        </div>
                      </div>

                      <div className={cx('examResult')}>
                        <div className={cx('chartData-icon red')} />
                        <div className={cx('examResult-title')}>
                          {defineMessages(formatMessage({ id: 'Target_26', defaultMessage: 'PC 감염' }))}
                        </div>
                        <div className={cx('ea')}>
                          {(!!mergeDetail.infection ? mergeDetail.infection : 0) +
                            defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                        </div>
                      </div>

                      <div className={cx('examResult')}>
                        <div className={cx('chartData-icon cure')} />
                        <div className={cx('examResult-title')}>
                          {defineMessages(formatMessage({ id: 'Target_28', defaultMessage: '치료' }))}
                        </div>
                        <div className={cx('ea')}>
                          {(!!mergeDetail.cure ? mergeDetail.cure : 0) +
                            defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {commonVar.isDeclare === 1 && (
                  <div className={cx('targetStatus mt-10')}>
                    <div className={cx('targetStatus-title')}>
                      {defineMessages(formatMessage({ id: 'Declare_8', defaultMessage: '신고 이력이 있는 대상자' }))}
                    </div>
                    <div className={cx('targetStatus-content ml-10')}>
                      {(!!mergeDetail.declare ? mergeDetail.declare : 0) +
                        defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* ----------------------------------------- 직급, 소속 수정 ----------------------------------------- */}
            {/* <div className={cx('element targetEdit')}>
              <div
                className={cx('segment-title')}
                ref={ref => {
                  onRefRegister('move-1', ref);
                }}>
                <span className={cx('toggle-title bold')}>
                  {defineMessages(formatMessage({ id: 'ExamDetailMulti_', defaultMessage: '대상자 수정' }))}
                </span>
              </div>
              <div className={cx('segment-content')}>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetDetailMulti-status editMode-area')}>
                    <ReduxFormMaterialTextField
                      className={cx('target-textField')}
                      placeholder={'소속을 일괄로 수정합니다.'}
                      name="targetDivision"
                      validate={['targetDivision']}
                      checkType={101}
                    />
                    <div className={cx('bt-icon-area')}>
                      <Button
                        className={cx('bt-icon')}
                        icon
                        title={defineMessages(formatMessage({ id: 'TargetDetail_6', defaultMessage: '저장' }))}
                        onClick={() => {
                          // onEditSave();
                        }}>
                        <Icon name="checkmark" />
                      </Button>
                      <Button
                        className={cx('bt-icon')}
                        icon
                        title={defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취소' }))}
                        onClick={() => {
                          // onEditCancel();
                        }}>
                        <Icon name="cancel" />
                      </Button>
                    </div>
                  </div>
                </div>
                <div className={cx('targetStatus')}>
                  <div className={cx('targetDetailMulti-status editMode-area')}>
                    <ReduxFormMaterialTextField
                      className={cx('target-textField')}
                      placeholder={'직급을 일괄로 수정합니다.'}
                      name="targetPosition"
                      validate={['targetPosition']}
                      checkType={101}
                    />
                    <div className={cx('bt-icon-area')}>
                      <Button
                        className={cx('bt-icon')}
                        icon
                        title={defineMessages(formatMessage({ id: 'TargetDetail_6', defaultMessage: '저장' }))}
                        onClick={() => {
                          // onEditSave();
                        }}>
                        <Icon name="checkmark" />
                      </Button>
                      <Button
                        className={cx('bt-icon')}
                        icon
                        title={defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취소' }))}
                        onClick={() => {
                          // onEditCancel();
                        }}>
                        <Icon name="cancel" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            {/* ----------------------------------------- Tags ----------------------------------------- */}
            <div
              className={cx('element', 'tag-element')}
              ref={ref => {
                onRefRegister('move-2', ref);
              }}>
              <div className={cx('segment-title')}>
                <span className={cx('toggle-title bold')}>
                  {defineMessages(formatMessage({ id: 'ExamDetailMulti_2', defaultMessage: '태그' }))}
                </span>
                <div className={cx('tag-title')}>
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'ExamDetailMulti_5', defaultMessage: '태그 일괄 추가' }))}
                    placement="bottom">
                    <Button
                      className={cx('bt-icon-tagTarget')}
                      icon
                      onClick={() => {
                        onToggleModal('tagTargetAdd');
                      }}>
                      <Icon name="add" />
                    </Button>
                  </Tooltip>
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'ExamDetailMulti_6', defaultMessage: '태그 일괄 삭제' }))}
                    placement="bottom">
                    <Button
                      className={cx('bt-icon-tagTarget')}
                      icon
                      onClick={() => {
                        onToggleModal('tagTargetDelete');
                      }}>
                      <Icon name="trash" />
                    </Button>
                  </Tooltip>
                </div>
              </div>
              <div className={cx('segment-content', 'tag-content', 'target-tags')}>{TagListComponent}</div>
              <div className={cx('bt-modal-area')}>
                {/* 태그 일괄 추가 모달 */}
                {isModal === 'tagTargetAdd' && (
                  <ModalTagTargetAdd
                    visible
                    isClicked={isClicked}
                    errorMessage={errorMessage}
                    tagDataArray={tagAddArray}
                    addTagNoArray={tagTargetArray}
                    onAddTagTarget={onAddTagTarget}
                    onToggleModal={onToggleModal}
                    handleChangeModalTag={handleChangeModalTag}
                    handleSearchChange={handleSearchChange}
                    handleBlur={handleBlur}
                    searchText={searchText}
                  />
                )}
                {/* 태그 일괄 삭제 모달 */}
                {isModal === 'tagTargetDelete' && (
                  <ModalTagTargetDelete
                    visible
                    isClicked={isClicked}
                    errorMessage={errorMessage}
                    tagDataArray={tagDeleteArray}
                    deleteTagNoArray={tagTargetArray}
                    onDeleteTagTarget={onDeleteTagTarget}
                    onToggleModal={onToggleModal}
                    handleChangeModalTag={handleChangeModalTag}
                  />
                )}
              </div>
            </div>
          </div>
        </Scrollbar>
      </DetailTemplate>
    );
  }
}

const mapStateToProps = (state, { isEditType, isEditData }) => {
  return {
    initialValues: {
      [isEditType]: isEditType !== '' && isEditData.get(isEditType)
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({ form: 'formTargetEdit', enableReinitialize: true })(injectIntl(TargetDetailMulti))
);



// WEBPACK FOOTER //
// ./src/script/components/target/TargetDetailMulti.js